<template>
    <!--
        The ordering PIN (libs/orderPin.ts): four digits the desk said at check-in, asked
        before an order or a booking goes through. One window for the whole portal.
    -->
    <div class="modalbg" :class="{ open: orderPinPrompt.open }" @click.self="cancel">
        <div class="modal">
            <h2>{{ $t('order_pin.title') }}</h2>
            <p class="muted">{{ $t('order_pin.hint') }}</p>

            <div class="field" style="margin-top:14px">
                <label for="order-pin">{{ $t('order_pin.label') }}</label>
                <input
                    id="order-pin"
                    ref="input"
                    v-model="pin"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    :maxlength="PIN_LENGTH"
                    style="font-size:26px;letter-spacing:.5em;text-align:center"
                    @keyup.enter="submit"
                >
                <p v-if="orderPinPrompt.wrong" class="warn" style="margin:8px 0 0">{{ $t('order_pin.wrong') }}</p>
            </div>

            <div class="actions">
                <button class="secondary" @click="cancel">{{ $t('general.cancel') }}</button>
                <button class="primary" :disabled="pin.length !== PIN_LENGTH" @click="submit">{{ $t('order_pin.confirm') }}</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { nextTick, ref, useTemplateRef, watch } from 'vue'

    import { answerOrderPin, orderPinPrompt } from '@/libs/orderPin'

    /** DataStructures.OrderPinLength. */
    const PIN_LENGTH = 4

    const pin   = ref('')
    const input = useTemplateRef<HTMLInputElement>('input')

    // Digits only: a telephone keyboard offers letters even with inputmode set.
    watch(pin, (value) => {
        const digits = value.replace(/\D/g, '').slice(0, PIN_LENGTH)

        if (digits !== value) pin.value = digits
    })

    // Every opening starts empty — the last PIN is not kept, not even for the retry.
    watch(() => orderPinPrompt.value.open, async (open) => {
        pin.value = ''

        if (open) {
            await nextTick()
            input.value?.focus()
        }
    })

    const submit = () => {
        if (pin.value.length === PIN_LENGTH) answerOrderPin(pin.value)
    }

    const cancel = () => answerOrderPin(null)
</script>
